var $8d03819f0bfc0fc0$exports = {};
let $8d03819f0bfc0fc0$var$theme = "dark";
try {
    $8d03819f0bfc0fc0$var$theme = localStorage.getItem("theme") || "dark";
} catch  {}
document.documentElement.dataset.theme = $8d03819f0bfc0fc0$var$theme === "light" ? "light" : "dark";


//# sourceMappingURL=acilione.github.io.82430209.js.map
